import { COUPON } from '../../CruiseSearchContext/constants';

export const applyTargetedOffer = ({
	offer,
	updateState,
	addToQualifiersSelecting,
	fetchAndUpdateFacetOptions,
	applyFilters,
}) => {
	updateState({
		targetedOfferApplied: offer,
		targetedOfferSelected: offer,
		uniqueDestinations: [],
	});
	addToQualifiersSelecting(`${COUPON}:${offer.couponCode}`, true, () => {
		fetchAndUpdateFacetOptions();
		applyFilters();
	});
};
